export const ASSOCIATION_DEFAULT_LOGO = "/img/no-image.jpg";

export const DEFAULT_ASSOCIATION_SETTINGS = {
  nom_club: "",
  shortname_club: "",
  responsable_club: "",
  logo_club: "",
  adresse_club: "",
  commune_club: "",
  tel_club: "",
  mail_club: "",
  siteweb_club: "",
  siret_club: "",
  facebook_club: "",
  instagram_club: "",
  primary_color: "#4f46e5",
  autorisation_renouvellement: false,
  saison_active: "",
};

export function unwrapSettings(data) {
  if (Array.isArray(data)) return data[0] || null;
  return data || null;
}

export function normalizeSettingsPayload(settings) {
  return {
    ...settings,
    nom_club: String(settings?.nom_club || "").trim(),
    shortname_club: String(settings?.shortname_club || "").trim(),
    responsable_club: String(settings?.responsable_club || "").trim(),
    logo_club: String(settings?.logo_club || "").trim(),
    adresse_club: String(settings?.adresse_club || "").trim(),
    commune_club: String(settings?.commune_club || "").trim(),
    tel_club: String(settings?.tel_club || "").trim(),
    mail_club: String(settings?.mail_club || "").trim(),
    siteweb_club: String(settings?.siteweb_club || "").trim(),
    siret_club: String(settings?.siret_club || "").trim(),
    facebook_club: String(settings?.facebook_club || "").trim(),
    instagram_club: String(settings?.instagram_club || "").trim(),
    primary_color: settings?.primary_color || "#4f46e5",
    autorisation_renouvellement: !!settings?.autorisation_renouvellement,
    saison_active: String(settings?.saison_active || "").trim(),
  };
}

export function validateAssociationSettings(settings) {
  if (!String(settings?.nom_club || "").trim()) {
    return "Le nom du club est requis.";
  }

  if (!String(settings?.shortname_club || "").trim()) {
    return "Le nom raccourci du club est requis.";
  }

  if (
    settings?.mail_club &&
    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(settings.mail_club).trim())
  ) {
    return "L’adresse email du club n’est pas valide.";
  }

  return "";
}

export function validateImageFile(file) {
  if (!file) return "";

  const validType = /^image\/(png|jpe?g|webp|svg\+xml)$/i.test(file.type);

  if (!validType) {
    return "Format image non supporté. Utilisez PNG, JPG, WEBP ou SVG.";
  }

  if (file.size > 10 * 1024 * 1024) {
    return "Image trop volumineuse. Taille maximale : 10 Mo.";
  }

  return "";
}

export function withBust(url, version) {
  if (!url) return url;
  return `${url}${url.includes("?") ? "&" : "?"}v=${version}`;
}

export function getSeasonOptions() {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth();

  const startYear = currentMonth >= 7 ? currentYear : currentYear - 1;

  return [`${startYear}-${startYear + 1}`, `${startYear + 1}-${startYear + 2}`];
}

export function countFilled(settings, keys) {
  return keys.reduce((count, key) => {
    return String(settings?.[key] || "").trim() ? count + 1 : count;
  }, 0);
}

export function calculateAssociationStats(settings) {
  const identityKeys = [
    "nom_club",
    "shortname_club",
    "responsable_club",
    "siret_club",
  ];

  const contactKeys = ["adresse_club", "commune_club", "tel_club", "mail_club"];

  const webKeys = ["siteweb_club", "facebook_club", "instagram_club"];

  const identityFilled = countFilled(settings, identityKeys);
  const contactFilled = countFilled(settings, contactKeys);
  const webFilled = countFilled(settings, webKeys);

  return {
    identityFilled,
    identityTotal: identityKeys.length,

    contactFilled,
    contactTotal: contactKeys.length,

    webFilled,
    webTotal: webKeys.length,

    hasLogo: !!String(settings?.logo_club || "").trim(),
    hasSeason: !!String(settings?.saison_active || "").trim(),
    renewalEnabled: !!settings?.autorisation_renouvellement,
  };
}

export function extractLogoUrl(response) {
  const data = response?.data ?? response;

  return (
    data?.url ||
    data?.logo_club ||
    data?.logoUrl ||
    data?.data?.url ||
    data?.data?.logo_club ||
    ""
  );
}